import SurfaceGeneratorPage from "@/components/SurfaceGeneratorPage";

const PLATFORMS = ["Facebook Group", "LinkedIn Personal", "LinkedIn Company", "Skool", "X / Twitter"];
const STYLES = ["Conversation starter", "Authority insight", "Poll", "Story", "CTA-focused"];
const OBJECTIVES = ["Comments", "Clicks", "DMs", "Saves", "Shares"];

const CONTEXT_FIELDS = [
  // ── Always visible ──
  { key: "post_format", label: "Post Format", type: "select", options: ["Text Only", "Image + Caption", "Link Share", "Poll", "Carousel / Document"], showWhen: { always: true }, section: "Post Setup" },
  { key: "hashtag_count", label: "Hashtag Strategy", type: "select", options: ["None", "1-3 (minimal)", "3-5 (moderate)", "5-10 (discovery-focused)"], showWhen: { always: true }, section: "Post Setup" },
  { key: "include_cta_comment", label: "Include Call to Comment", type: "toggle", placeholder: "End with a question or engagement prompt", showWhen: { always: true }, section: "Post Setup" },

  // ── Poll ──
  { key: "poll_question", label: "Poll Question", type: "text", placeholder: "e.g., What's your biggest bottleneck right now?", showWhen: { mode: ["Poll"] }, section: "Poll Setup", half: false },
  { key: "poll_option_1", label: "Option 1", type: "text", placeholder: "e.g., Not enough leads", showWhen: { mode: ["Poll"] }, section: "Poll Setup" },
  { key: "poll_option_2", label: "Option 2", type: "text", placeholder: "e.g., Can't close the ones I have", showWhen: { mode: ["Poll"] }, section: "Poll Setup" },
  { key: "poll_option_3", label: "Option 3", type: "text", placeholder: "e.g., Fulfillment is overwhelming", showWhen: { mode: ["Poll"] }, section: "Poll Setup" },
  { key: "poll_option_4", label: "Option 4 (optional)", type: "text", placeholder: "e.g., All of the above", showWhen: { mode: ["Poll"] }, section: "Poll Setup" },

  // ── X / Twitter ──
  { key: "thread_mode", label: "Thread Mode", type: "toggle", placeholder: "Generate as multi-tweet thread (not single tweet)", showWhen: { platform: ["X / Twitter"] }, section: "Twitter / X Options" },
  { key: "thread_length", label: "Thread Length", type: "select", options: ["3-5 tweets", "5-8 tweets", "8-12 tweets"], showWhen: { platform: ["X / Twitter"] }, section: "Twitter / X Options", hint: "280 character max per tweet" },

  // ── Facebook Group / Skool ──
  { key: "group_name", label: "Group / Community Name", type: "text", placeholder: "e.g., SaaS Growth Hackers, Coaching Business Builders", showWhen: { platform: ["Facebook Group", "Skool"] }, section: "Community Context" },
  { key: "group_rules_context", label: "Group Norms / Rules to Respect", type: "text", placeholder: "e.g., No direct links, no self-promo on Mondays", showWhen: { platform: ["Facebook Group", "Skool"] }, section: "Community Context", half: false },

  // ── LinkedIn ──
  { key: "li_doc_slides", label: "Number of Document Slides", type: "select", options: ["5", "7", "10", "12"], showWhen: { platform: ["LinkedIn Personal", "LinkedIn Company"], mode: ["Authority insight", "CTA-focused"] }, section: "LinkedIn Options", hint: "For carousel/document posts" },

  // ── Story mode ──
  { key: "story_hook", label: "Story Starting Point", type: "text", placeholder: "e.g., Last Tuesday a client called me in a panic...", showWhen: { mode: ["Story"] }, section: "Story Context", half: false },
  { key: "story_lesson", label: "The Lesson / Takeaway", type: "text", placeholder: "What should the reader walk away believing?", showWhen: { mode: ["Story"] }, section: "Story Context", half: false },
];

export default function CommunityComposerPage() {
  return (
    <SurfaceGeneratorPage
      badge="Community"
      title="Community Composer"
      description="Create platform-specific community posts with format-aware inputs and engagement optimization."
      contentType="Community Post"
      platformLabel="Community platform"
      platforms={PLATFORMS}
      modeLabel="Style mode"
      modes={STYLES}
      objectiveLabel="Engagement objective"
      objectives={OBJECTIVES}
      helperText="Add offer context, community rules to follow, or link guidance."
      contextFields={CONTEXT_FIELDS}
    />
  );
}
